import React, { useEffect, useRef } from 'react'

import { Subtotal } from 'stores/ooka_usa_store/airglobal/pylot-custom-kit-flow/src/Components/Subtotal/Subtotal'
import Image from '@corratech/pylot-image'
import { useTranslation } from 'next-i18next'
import { Button } from '@corratech/pylot-ui'
import { FlavourActionProps } from '../../lib/type'
import FlavourSwatch from '../icons/FlavourSwatch'

import cn from 'classnames'
import fs from 'stores/ooka_usa_store/airglobal/pylot-custom-kit-flow/src/Components/FlavoursStep/Flavours.module.scss'
import { useDragScroll } from 'stores/ooka_usa_store/airglobal/pylot-custom-kit-flow/src/utils/useDragScroll'
import { useUI } from '@corratech/pylot-ui/context'

export const FlavourAction = ({
    flavour,
    packAmount,
    product,
    selectedOptions,
    flavours,
    selectedOptionsFlavours,
    setStep,
    step,
    isAddToCartInProgress,
    addProductHandler,
    isFavourite,
    addOns
}: FlavourActionProps): JSX.Element => {
    const [dragElRef] = useDragScroll()
    const { t } = useTranslation(['common', 'plp'])
    const { cartEditId } = useUI()
    const requiredFlavours = flavours?.filter((flavour) => flavour?.required)
    const flavourContainerRef = useRef<HTMLDivElement | null>(null)

    const buttonLabel = (): string => {
        const label = product?.upsell_products?.length

        if (cartEditId) return t(isAddToCartInProgress ? 'Updating' : 'UPDATE')
        if (label) return t('CONTINUE')
        return t(isAddToCartInProgress ? 'Adding product' : 'Go to Checkout')
    }

    const selectedFavFlavour = selectedOptionsFlavours.find((option) => option)

    useEffect(() => {
        if (selectedOptionsFlavours.length > 5 && flavourContainerRef.current) {
            const container = flavourContainerRef.current
            const lastFlavourIndex = selectedOptionsFlavours.length - 1
            const lastFlavourElement = container.children[lastFlavourIndex]

            if (lastFlavourElement) {
                const offsetLeft = (lastFlavourElement as HTMLElement)
                    .offsetLeft
                const containerWidth = container.clientWidth
                const scrollLeft =
                    offsetLeft -
                    containerWidth / 2 +
                    (lastFlavourElement as HTMLElement).clientWidth / 2

                container.scrollTo({
                    left: scrollLeft,
                    behavior: 'smooth'
                })
            }
        } else if (
            selectedOptionsFlavours.length <= 5 &&
            flavourContainerRef.current
        ) {
            flavourContainerRef.current.scrollTo({
                left: 0,
                behavior: 'smooth'
            })
        }
    }, [selectedOptionsFlavours])

    return (
        <div
            className={cn(
                fs['price-container'],
                fs['flavour-acion-section'],
                'flex flex-col'
            )}
        >
            <div className={cn(fs['action-section'])}>
                {isFavourite ? (
                    <div className={fs['flav-container']}>
                        <div>
                            <div className={fs['price']}>
                                <h5 className={fs['subtotal-text']}>
                                    {flavours?.length ===
                                    selectedOptionsFlavours.length
                                        ? t(`${selectedFavFlavour?.label}`)
                                        : t(
                                              'Tap on a Flavor to make a selection'
                                          )}
                                </h5>
                            </div>
                        </div>
                    </div>
                ) : (
                    <>
                        <div className={fs['flav-container']}>
                            <div className={cn(fs['flav-price'])}>
                                {selectedOptionsFlavours?.length > 0 && (
                                    <div className={fs['disclaimer']}>{`${
                                        selectedOptionsFlavours?.length
                                    }  packs ( ${
                                        selectedOptionsFlavours?.length * 2
                                    } pods )`}</div>
                                )}
                                <Subtotal
                                    product={product}
                                    selectedOptions={selectedOptions}
                                    addOns={addOns}
                                />
                            </div>
                        </div>
                        <div
                            className={cn(fs['flavours'])}
                            ref={(el) => {
                                dragElRef(el)
                                flavourContainerRef.current = el
                            }}
                        >
                            {flavours?.map((flavour, index) => {
                                if (selectedOptionsFlavours?.[index]) {
                                    const selectedProduct =
                                        selectedOptionsFlavours?.[index]
                                            ?.product
                                    const img = selectedProduct?.kit_image?.url
                                    return (
                                        <div
                                            key={flavour?.uid}
                                            onDragStart={(e) =>
                                                e.preventDefault()
                                            }
                                            className={
                                                fs['flavour-swatch-image']
                                            }
                                        >
                                            <Image
                                                className={fs['small-image']}
                                                src={img!}
                                                alt={selectedProduct?.name!}
                                                height="100%"
                                                width={38}
                                                objectFit="contain"
                                                key={selectedProduct?.sku}
                                            />
                                        </div>
                                    )
                                }
                                return (
                                    <div key={flavour?.uid}>
                                        <FlavourSwatch className="flex h-full" />
                                    </div>
                                )
                            })}
                        </div>
                    </>
                )}

                <div className={cn(fs['flavours-btn'])}>
                    <Button
                        type="button"
                        className={cn('add-to-cart-button', fs['custom-btn'])}
                        loading={isAddToCartInProgress}
                        disabled={
                            isAddToCartInProgress ||
                            !selectedOptionsFlavours?.length ||
                            selectedOptionsFlavours?.length <
                                (requiredFlavours?.length ?? 0)
                        }
                        onClick={() => {
                            if (
                                setStep &&
                                typeof step == 'number' &&
                                requiredFlavours &&
                                selectedOptionsFlavours?.length >=
                                    requiredFlavours?.length
                            ) {
                                if (product?.upsell_products?.length) {
                                    setStep(step + 1)
                                } else if (addProductHandler) {
                                    addProductHandler(null)
                                }
                            }
                        }}
                    >
                        {buttonLabel()}
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default FlavourAction
